import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const MAX_RECENT_SEARCHES = 5;

type TInsightsSearchHistoryStore = {
  recentSearches: string[];
  addRecentSearch: (query: string) => void;
  removeRecentSearch: (query: string) => void;
  clearRecentSearches: () => void;
};

export const useInsightsSearchHistoryStore = create<TInsightsSearchHistoryStore>()(
  persist(
    (set) => ({
      recentSearches: [] as string[],

      addRecentSearch: (query) =>
        set((state) => {
          const trimmed = query.trim().toLowerCase();
          if (!trimmed) return state;

          // Remove entries where one is a prefix of the other (iOS pattern)
          const filtered = state.recentSearches.filter(
            (existing) => !existing.startsWith(trimmed) && !trimmed.startsWith(existing),
          );

          return { recentSearches: [trimmed, ...filtered].slice(0, MAX_RECENT_SEARCHES) };
        }),

      removeRecentSearch: (query) =>
        set((state) => ({
          recentSearches: state.recentSearches.filter((s) => s !== query),
        })),

      clearRecentSearches: () => set({ recentSearches: [] }),
    }),
    {
      name: 'insights-search-history',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
